
import React from 'react';

interface ProjectDetailsOverlayProps {
  projectName: string;
  selectedStructure: string;
  directorsCount: number;
  managersCount: number;
  teamMembersCount: number;
  isEditable: boolean;
}

export const ProjectDetailsOverlay = ({
  projectName,
  selectedStructure,
  directorsCount,
  managersCount,
  teamMembersCount,
  isEditable
}: ProjectDetailsOverlayProps) => {
  return (
    <div className="absolute top-4 left-4 z-10 bg-black/80 text-white px-4 py-2 rounded-lg text-xs max-w-[200px]">
      <h4 className="font-semibold mb-1">Project Requirements</h4>
      <ul className="space-y-0.5">
        <li>Project: {projectName}</li>
        <li>Structure: {selectedStructure}</li>
        <li>Directors: {directorsCount}</li>
        <li>Managers: {managersCount}</li>
        <li>Team Members: {teamMembersCount}</li>
        <li>Editable: {isEditable ? 'Yes' : 'No'}</li>
      </ul>
    </div>
  );
};
